<template>
	<div class="box">
		<top />
		<div class="container">
			<div class="content">
				<div class="warp">
					<div class="left">
						<div class="photo">
							<div class="choose">
								<div class="up" @click="up">
									<i class="el-icon-caret-top" style="color: #b7b7b7"></i>
								</div>
								<div class="choose-box">
									<div class="wrap" :style="{ top: -index * 118.3 + 'px' }">
										<div class="item" v-for="(item, index) in clothingTem" :key="index"
											@click="change(index)">
											<img :src="imageUrl(item.arctype_clothes_img)" alt="以图绘图印花设计网" />
										</div>
									</div>
								</div>
								<div class="down" @click="down">
									<i class="el-icon-caret-bottom" style="color: #1a3c59"></i>
								</div>
							</div>
						</div>
						<div class="df">
							<div class="img-box">
								<img class="img1" :src="imageUrl(clothingTem[active].arctype_clothes_img)"
									alt="以图绘图印花设计网" v-if="clothingTem.length" />
								<div v-if="fourConsecutive == true" id="img" class="logo" :style="{
                    width: width + 'px',
                    height: height + 'px',
                    top: top + 'px',
                    left: left + 'px',
                    backgroundImage: 'url(' + imgs + ')',
                    backgroundSize: bcSize + 'px',
                  }"></div>
								<img v-if="fourConsecutive == false" id="img" class="logo" :src="imgs"
									:alt="'以图绘图印花设计网-' + imgsname" :style="{
                    width: width + 'px',
                    height: height + 'px',
                    top: top + 'px',
                    left: left + 'px',
                    transform: `scale(${diploid}, ${diploid})`,
                  }" />
								<div class="bj" :style="{ backgroundColor: bc }"></div>
							</div>
							<div class="df_flex">
								<el-progress :text-inside="true" :stroke-width="25" :format="format"
									:percentage="(archivesInfo.sales_num / hot_max) * 100 || 0"
									status="exception"></el-progress>
								<div class="Hot" :style="{
                    left: 50 + `%`,
                  }"> 火爆指数 </div>
							</div>
						</div>
					</div>
					<div class="right">
						<div class="uname-box">
							<div class="name">{{ archivesInfo.title }}</div>
							<div class="follow" v-if="follow == 'no'" @click="fllowDo(1)"> 关注+ </div>
							<div class="follow" v-else @click="fllowDo(2)">已关注</div>
						</div>
						<div class="user-info">
							<div class="touxiang" @click="goAuthor(archivesInfo.users_id)">
								<img :src="imageUrl(archivesInfo.head_pic)" :alt="'以图绘图印花设计网-' + archivesInfo.author" />
							</div>
							<div class="user-content">
								<p>上传者：{{ archivesInfo.author }}</p>
								<p>发布时间：{{ archivesInfo.update_time }}</p>
							</div>
						</div>
						<div class="shop-info">
							<div class="shop-info-item">
								<div style="width: 50%">
									<span style="color: #666666">编号</span><span>{{ archivesInfo.aid }}</span>
								</div>
								<div style="width: 50%">
									<span style="color: #666666">格式</span><span>{{ archivesInfo.format }}</span>
								</div>
							</div>
							<!-- <div class="shop-info-item">
                <div style="width: 50%">
                  <span style="color: #666666">模式</span
                  ><span>{{ archivesInfo.pattern }}</span>
                </div>
                <div style="width: 50%">
                  <span style="color: #666666">尺寸</span
                  ><span>{{ archivesInfo.size }}</span>
                </div>
              </div> -->
						</div>
						<el-divider></el-divider>
						<div class="use-box">
							<div class="no"></div>
							<div class="problem">
								<span @click="protocol('copyrightissues')">版权问题!</span>
								<span @click="protocol('salesproblems')">售后问题</span>
							</div>
						</div>
						<div class="price-box">
							<div class="price">
								<span v-if="level != 1"> 原价<span
										style="color: #888; padding: 0 5px;text-decoration: line-through;">￥{{ archivesInfo.line_price }}</span>
								</span> 价格<span
									style="color: #e66617; padding-left: 18px;text-decoration: line-through;">￥{{ archivesInfo.users_price }}</span>
								<span class="car" style="cursor: pointer;"
									@click="go('/buyer/downmeal')">点我下载低至0.5元起</span>
							</div>
							<!-- <div class="getuser" v-if="level == 1" @click="go('/buyer/downmeal')"> 点击购买套餐即享优惠 </div> -->
						</div>
						<div class="download-box">
							<div class="upload" v-if="!isShow" @click="getShopInfo"> 下载源文件 </div>
							<div class="upload" v-else @click="getShopInfo">下载中</div>
							<div class="car">
								<img style="widrh: 28px; height: 25px" src="@/assets/car-y.png" alt="" />
								<span style="padding-left: 17px" @click="joinCartDo"> 加入购物车</span>
							</div>
						</div>
					</div>
				</div>
				<div class="function-box">
					<div class="enlarge">
						<div style="font-size: 180%">
							<i class="el-icon-caret-top" style="cursor: pointer" @click="top -= 5"></i>
							<i class="el-icon-caret-bottom" style="margin-left: 24px; cursor: pointer"
								@click="top += 5"></i>
						</div>
						<div style="font-size: 180%">
							<i class="el-icon-caret-left" style="cursor: pointer" @click="left -= 5"></i>
							<i class="el-icon-caret-right" style="margin-left: 24px; cursor: pointer"
								@click="left += 5"></i>
						</div>
						<div style="font-size: 180%">
							<i class="el-icon-zoom-in" style="cursor: pointer" @click="add"></i>
							<i class="el-icon-zoom-out" style="margin-left: 24px; cursor: pointer" @click="del"></i>
						</div>
					</div>
					<el-button class="keep" style="width: 85px; margin-left: 60px; cursor: pointer" @click="rect">重置
					</el-button>
					<el-button class="keep" style="width: 103px; cursor: pointer; margin-left: 60px"
						@click="show = true">细节图</el-button>
					<el-button class="keep" style="width: 103px; cursor: pointer; margin-left: 60px"
						@click="searchImgUploadBase64">查看相似</el-button>
				</div>
			</div>
		</div>
		<div class="title-box">
			<div class="title">作者其他作品</div>
		</div>
		<order :list="authorAbout" />
		<div class="title-box">
			<div class="title">热门设计师</div>
		</div>
		<div style="padding-bottom: 104px">
			<c-swiper :propOption="swipeBoxSpace" :designers="designersData" v-if="designersData"></c-swiper>
		</div>
		<foot />
		<!-- 细节图开始 -->
		<el-dialog :visible.sync="show" width="46%">
			<div class="show">
				<img :src="imageUrl(archivesInfo.litpic_watermark)" :alt="'以图绘图印花设计网-' + imgsname" />
			</div>
		</el-dialog>
		<!-- 细节图结束 -->
		<!-- 细节图开始 -->
		<el-dialog title="提示" :visible.sync="merchandise" width="30%" center>
			<el-form label-position="left" label-width="80px">
				<el-form-item label="网盘链接"> {{ panUrl }} </el-form-item>
				<el-form-item label="网盘密码"> {{ panPass }} </el-form-item>
			</el-form>
		</el-dialog>
		<loading ref="loading"></loading>
		<!-- 细节图结束 -->
		<!-- 购买弹窗 -->
		<el-dialog title="提示" :visible.sync="buyShow" width="25%" center class="new-car">
			<el-divider></el-divider>
			<div class="govip">确定购买该素材吗?</div>
			<div class="offline">
				<!--  通联支付 -->
				<div @click="choose('tlwechat')">
					<img src="../../assets/wx1.png" alt="" v-if="selectedMethod === 'tlwechat'" />
					<img src="../../assets/wx2.png" alt="" v-else />
				</div>
				<div @click="choose('tlalipay')">
					<img src="../../assets/zfb1.png" alt="" v-if="selectedMethod === 'tlalipay'" />
					<img src="../../assets/zfb2.png" alt="" v-else />
				</div>
				<!--        <div @click="choose('tlunion')">-->
				<!--          <img src="../../assets/ysf1.png" alt="" v-if="selectedMethod === 'tlunion'" />-->
				<!--          <img src="../../assets/ysf2.png" alt="" v-else />-->
				<!--        </div>-->
				<div @click="choose('balance')">
					<img src="../../assets/balance1.png" alt="" v-if="selectedMethod === 'balance'" />
					<img src="../../assets/balance2.png" alt="" v-else />
				</div>
				<!--  end -->
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="buy" style="background: #09253d; border: none; width: 120px">确 定
				</el-button>
				<el-button @click="buyShow = false" style="
				background: #c92323;
				color: #ffffff;
				border: none;
				width: 120px;
				margin-left: 94px;
			  ">取 消</el-button>
			</span>
		</el-dialog>
		<!-- 支付弹窗 -->
		<el-dialog :title="dialogTitle" :visible.sync="bounced" width="20%" :close-on-click-modal="isClose" center
			class="qr_new">
			<vue-qr style="margin: 0 auto" :text="downloadData.url" :margin="0" colorDark="black" colorLight="#fff"
				:size="200"></vue-qr>
		</el-dialog>
	</div>
</template>
<script>
	import Loading from "../../components/loading.vue";
	import top from "../../components/common/header.vue";
	import order from "../../components/open-list/open-list.vue";
	import Swiper from "../../components/designer/swiper.vue";
	import SwiperGroup from "../../components/designer/swipe-group.vue";
	import foot from "../../components/common/footer.vue";
	import {
		openAreaDetail,
		fllowDo,
		joinCart,
		sourceDetailorder,
		checkUserOrder,
		checkUserOrders,
		upcolor,
		downMealBuy,
		pay_tonglian,
		select_pay_method,
		order_pay_polling,
		searchImgUploadBase64
	} from "../../request/api";
	import vueQr from "vue-qr";
	export default {
		components: {
			top,
			order,
			"c-swiper": Swiper,
			"c-swiper-group": SwiperGroup,
			foot,
			Loading,
			vueQr,
		},
		mounted() {
			this.$loading = this.$refs.loading
		},
		data() {
			return {
				swipeBoxSpace: {
					propId: "swipeBoxSpace",
					height: "280px",
					width: "1280px",
					slidesPerView: 5,
					spaceBetween: 45,
				},
				aid: "",
				archivesInfo: {
					sales_num: 0,
				}, //logo 信息
				authorAbout: "", //作者其他作品
				designersData: "", //热门设计师
				clothingTem: "", //衣服
				follow: "", //是否关注
				active: 0, //衣服选中
				top: 150,
				left: 150,
				width: 100,
				height: 100,
				diploid: 1, //放大倍数
				show: false,
				index: 0, //当前选中标识
				level: "", //用户等级
				merchandise: false, //商品弹框
				panUrl: "",
				panPass: "",
				imgs: null,
				bc: null,
				fourConsecutive: false,
				bcSize: 100,
				downloadUrl: "",
				isShow: false,
				hot_max: "",
				imgsname: "",
				buyShow: false,
				selectedMethod: "",
				dialogTitle: "打开微信扫一扫，向我付款", // 默认标题
				bounced: false, //充值弹框
				isClose: false,
				downloadData: {
					url: "扫码访问的链接地址",
					icon: "随便一张图片的地址也行",
				},
				orderInfo: {
					unified_id: "",
					unified_number: "",
				},
			};
		},
		created() {
			this.aid = this.$route.query.aid;
			this.getData();
			// this.$loading.show()
		},
		methods: {
			goAuthor(author_id) {
				this.$router.push({
					path: "/author",
					query: {
						author_id: author_id,
					},
				});
			},
			//获取数据
			getData() {
				openAreaDetail({
					aid: this.aid,
				}).then((res) => {
					if (res.code != 200) {
						this.$router.replace({
							path: '/'
						});
						return false;
					}
					this.archivesInfo = res.data.archivesInfo;
					this.authorAbout = res.data.authorAbout;
					this.designersData = res.data.designersData;
					this.clothingTem = res.data.clothingTem;
					this.follow = res.data.follow;
					this.hot_max = res.data.hot_max;
					if (this.archivesInfo.sales_num > this.hot_max) {
						this.archivesInfo.sales_num = this.hot_max;
					}
					this.level = res.data.level;
					let result = res.data.archivesInfo.typeid.split(",");
					if (this.archivesInfo.repeat != undefined) {
						this.top = 0;
						this.left = 0;
						this.width = 425;
						this.height = 444;
						this.fourConsecutive = true;
					}
					this.imgsname = this.archivesInfo.title;
					this.imgs = this.imageUrl(this.archivesInfo.litpic);
					this.getBodymovinJson();
					document.title = '以图绘图印花设计网-' + this.archivesInfo.title;
				});
			},
			ucolor(color) {
				upcolor({
					aid: this.aid,
					color: color
				}).then((res) => {})
			},
			up() {
				if (this.index == this.clothingTem.length - 4) {
					return;
				}
				this.index++;
			},
			down() {
				if (this.index == 0) {
					return;
				}
				this.index--;
			},
			add() {
				if (this.fourConsecutive == true) {
					this.bcSize = 100;
					this.diploid += 0.1;
					this.bcSize = this.bcSize * this.diploid;
					this.width = this.width * (this.bcSize / 100);
					this.height = this.height * (this.bcSize / 100);
				} else {
					this.diploid += 0.1;
				}
			},
			del() {
				if (this.fourConsecutive == true) {
					this.bcSize = 100;
					this.diploid -= 0.1;
					this.bcSize = this.bcSize * this.diploid;
					this.width = this.width * (100 / this.bcSize);
					this.height = this.height * (100 / this.bcSize);
				} else {
					this.diploid -= 0.1;
				}
			},
			//关注操作
			fllowDo(type) {
				fllowDo({
					aid: this.archivesInfo.users_id,
					type: type,
				}).then((res) => {
					if (res.code == 200) {
						this.getData();
					} else {
						this.$message.error(res.msg);
					}
				});
			},
			change(index) {
				this.active = index;
			},
			//重置
			rect() {
				if (this.fourConsecutive == true) {
					this.diploid = 1;
					this.top = 0;
					this.left = 0;
					this.width = 425;
					this.height = 444;
					this.bcSize = 100;
				} else {
					this.top = 150;
					this.left = 150;
					this.diploid = 1;
				}
			},
			//加入购物车
			joinCartDo() {
				joinCart({
					aid: this.aid,
					type: 1,
				}).then((res) => {
					console.log(res);
					if (res.code == 200) {
						this.$message({
							message: res.msg,
							type: "success",
						});
					} else {
						this.$message.error(res.msg);
					}
				});
			},
			format(percentage) {
				return percentage === 100 ? `${this.archivesInfo.sales_num}` : `${this.archivesInfo.sales_num}`;
			},
			downloadWithBlob(url) {
				this.isShow = true;
				fetch(url).then((res) => res.blob().then((blob) => {
					this.isShow = false;
					this.$loading.hide()
					this.$message({
						message: '下载完成',
						type: "success",
					});
					console.log(blob);
					var a = document.createElement("a");
					var name = url;
					var url = window.URL.createObjectURL(blob);
					var filename = this.archivesInfo.title + this.downloadUrl.substring(this.downloadUrl
						.lastIndexOf("."));
					console.log(filename);
					a.href = url;
					a.download = filename;
					a.click();
					window.URL.revokeObjectURL(url);
				}));
			},
			//查询是否购买
			getShopInfo() {
				var that = this
				this.$loading.show()
				checkUserOrder({
					aid: this.aid,
				}).then((res) => {
					if (res.code == 200) {
						this.panUrl = res.data.panurl;
						this.panPass = res.data.panpwd;
						this.downloadUrl = res.data.raw_litpic;
						if (typeof(res.data.raw_litpic) == "object" || res.data.raw_litpic == "") {
							this.merchandise = true;
						} else {
							window.open("/api/newapi/BuyOrder/downloadArchivesOne", "_self")
							setTimeout(function() {
								that.$message.success("开始下载");
								that.$loading.hide()
							}, 12000);
							// this.downloadWithBlob(res.data.raw_litpic);
						}
					}
					if (res.code == 300) {
						this.$confirm(res.msg, {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
						}).then(() => {
							checkUserOrders({
								aid: this.aid,
							}).then((res) => {
								if (res.code == 200) {
									this.panUrl = res.data.panurl;
									this.panPass = res.data.panpwd;
									this.downloadUrl = res.data.raw_litpic;
									if (typeof(res.data.raw_litpic) == "object" || res.data
										.raw_litpic == "") {
										this.merchandise = true;
									} else {
										// this.$message({
										// 	message: res.msg,
										// 	type: "success",
										// });
										window.open("/api/newapi/BuyOrder/downloadArchivesOne",
											"_self")
										setTimeout(function() {
											that.$message.success(res.msg);
											that.$loading.hide()
										}, 12000);
										// this.downloadWithBlob(res.data.raw_litpic);
									}
								}
								if (res.code == 500) {
									this.$message.error(res.msg);
								}
							});
						});
						that.$loading.hide()
					}
					if (res.code == 500) {
						this.buyShow = !this.buyShow;
						// this.upload();
						that.$loading.hide()
					}
					if (res.code == 505) {
						that.$loading.hide()
						this.$confirm(res.msg, {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
						}).then(() => {
							this.$router.push("/seller/sellerInfo");
						})
					}
				});
			},
			choose(method) {
				if (this.selectedMethod === method) {
					// 再次点击已选中的支付方式可取消选择
					this.selectedMethod = "";
				} else {
					this.selectedMethod = method;
				}
				if (this.selectedMethod === 'tlwechat') {
					this.dialogTitle = '打开微信扫一扫，向我付款';
				} else if (this.selectedMethod === 'tlalipay') {
					this.dialogTitle = '打开支付宝扫一扫，向我付款';
				} else if (this.selectedMethod === 'tlunion') {
					this.dialogTitle = '打开云闪付扫一扫，向我付款';
				} else {
					this.dialogTitle = '扫码支付';
				}
			},
			buy() {
				if (!this.selectedMethod) {
					this.$message.error("请选择支付方式");
					return;
				}
				sourceDetailorder({
					aid: this.aid,
					payment: this.selectedMethod
				}).then((res) => {
					if (res.code == 200) {
						if (this.selectedMethod === 'balance') {
							this.$message({
								message: res.msg,
								type: "success",
							});
							this.buyShow = false;
							this.$router.push("/buyer/buyOrder");
						} else {
							this.orderInfo.unified_id = res.data.order_id;
							this.orderInfo.unified_number = res.data.order_code;
							pay_tonglian({
								unified_number: this.orderInfo.unified_number,
								transaction_type: 8,
								payment: this.selectedMethod
							}).then((res) => {
								if (res.code == 200) {
									this.buyShow = false;
									this.downloadData.url = res.data;
									this.bounced = true;
									this.getSelect_pay_method();
								} else {
									this.$message.error(res.msg);
								}
							});
						}
					}
					if (res.code == 500) {
						this.$message.error(res.msg)
						this.buyShow = false;
					}
				});
			},
			//支付接口列表
			getSelect_pay_method() {
				select_pay_method({
					unified_id: this.orderInfo.unified_id,
					unified_number: this.orderInfo.unified_number,
					transaction_type: 8,
					// pay_mark: "wechat",
					// pay_id: 1,
					pay_mark: "allinpay",
					pay_id: 3,
				}).then((res) => {
					if (res.code == 200) {
						this.order_pay();
					} else {
						this.$message.error(res.msg);
						this.bounced = false;
					}
				});
			},
			//订单支付轮询
			order_pay() {
				var time = setInterval(() => {
					order_pay_polling({
						unified_id: this.orderInfo.unified_id,
						unified_number: this.orderInfo.unified_number,
						transaction_type: 8,
						// pay_mark: "wechat",
						// pay_id: 1,
						pay_mark: "allinpay",
						pay_id: 3,
					}).then((res) => {
						console.log("222", res);
						if (res.code == 200) {
							this.$message({
								message: res.msg,
								type: "success",
							});
							this.buyShow = false;
							this.bounced = false;
							clearInterval(time);
							this.$router.push("/buyer/buyOrder");
						}
					});
				}, 2000);
			},
			//下载
			upload() {
				this.$confirm("确定购买该素材吗?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					sourceDetailorder({
						aid: this.aid,
					}).then((res) => {
						if (res.code == 200) {
							this.$message({
								message: res.msg,
								type: "success",
							});
							this.$router.push("/buyer/buyOrder");
						}
						if (res.code == 500) {
							this.$message.error(res.msg);
						}
					});
				});
			},
			//协议
			protocol(type) {
				this.$router.push({
					path: "/clause",
					query: {
						type: type,
					},
				});
			},
			go(url) {
				this.$router.push(url);
			},
			getBodymovinJson() {
				var that = this;
				let image = that.imageUrl(that.archivesInfo.litpic);
				this.getBase64(image, (res) => {
					// console.log(res);
					that.imgs = res;
					setTimeout(function() {
						that.initCanvas();
					}, 500);
				});
			},
			getBase64(url, callback) {
				//通过构造函数来创建的 img 实例，在赋予 src 值后就会立刻下载图片，相比 createElement() 创建 <img> 省去了 append()，也就避免了文档冗余和污染
				var Img = new Image(),
					dataURL = "";
				// Img.src = url + "?v=" + Math.random(); // 处理缓存,fix缓存bug,有缓存，浏览器会报错;
				const separator = url.includes("?") ? "&" : "?";
				Img.src = url + separator + "v=" + Math.random(); // 使用 & 或 ? 正确拼接
				Img.setAttribute("crossOrigin", "Anonymous"); // 解决控制台跨域报错的问题
				Img.onload = function() {
					//要先确保图片完整获取到，这是个异步事件
					var canvas = document.createElement("canvas"), //创建canvas元素
						width = Img.width, //确保canvas的尺寸和图片一样
						height = Img.height;
					canvas.width = width;
					canvas.height = height;
					console.log(Img);
					console.log(width);
					console.log(height);
					canvas.getContext("2d").drawImage(Img, 0, 0, width, height); //将图片绘制到canvas中
					dataURL = canvas.toDataURL("image/png"); //转换图片为dataURL
					callback ? callback(dataURL) : null; //调用回调函数
				};
			},
			initCanvas() {
				var that = this;
				var img = document.getElementById("img");
				// var output = document.getElementById('output');
				var canvas = this.draw(img);
				var x = 0;
				var y = 0;
				var color = canvas.getColor(x, y).rgba;
				// document.body.style.background = color;
				console.log(color);
				that.bc = color;
				that.ucolor(color);
				canvas.canvas.remove();
				// output.innerHTML = '坐标点颜色：' + color;
			},
			draw(img) {
				var style = window.getComputedStyle(img);
				var width = parseInt(style.width, 10);
				var height = parseInt(style.height, 10);
				var canvas = document.createElement("canvas");
				canvas.width = width;
				canvas.height = height;
				var ctx = canvas.getContext("2d");
				ctx.drawImage(img, 0, 0);
				document.body.appendChild(canvas);
				// 获取坐标颜色
				function getPixelColor(x, y) {
					var imageData = ctx.getImageData(x, y, 1, 1);
					var pixel = imageData.data;
					console.log(pixel);
					var r = pixel[0];
					var g = pixel[1];
					var b = pixel[2];
					var a = pixel[3] / 255;
					a = Math.round(a * 100) / 100;
					var rHex = r.toString(16);
					r < 16 && (rHex = "0" + rHex);
					var gHex = g.toString(16);
					g < 16 && (gHex = "0" + gHex);
					var bHex = b.toString(16);
					b < 16 && (bHex = "0" + bHex);
					var rgbaColor = "rgba(" + r + "," + g + "," + b + "," + a + ")";
					var rgbColor = "rgb(" + r + "," + g + "," + b + ")";
					var hexColor = "#" + rHex + gHex + bHex;
					return {
						rgba: rgbaColor,
						rgb: rgbColor,
						hex: hexColor,
						r: r,
						g: g,
						b: b,
						a: a,
					};
				}
				return {
					getColor: getPixelColor,
					canvas: canvas,
				};
			},
			/**
			 * 将base64字符串转换为Blob对象(二进制)
			 * @param {String} base64Data - base64格式的图片字符串
			 * @returns {Blob} 转换后的二进制对象
			 */
			// 查看相似
			searchImgUploadBase64() {
				searchImgUploadBase64({
					file: this.imgs,
				}).then((res) => {
					// 先判断接口请求成功，再判断OSS上传成功（后端data.code=0）
					if (res.code === 200 && res.data.code === 0) {
						this.$router.push({
							path: "/search",
							query: {
								keysWord: "",
								imgs: 1,
								imgPath: res.data.img // 携带上传后的图片路径到搜索页
							},
						});
					}
				});
			}
		},
		watch: {
			$route: {
				// 亲测有效,我是用来监听query参数变化
				handler() {
					this.aid = this.$route.query.aid;
					this.getData();
					//深度监听，同时也可监听到param参数变化
				},
				deep: true,
			},
		},
	};
</script>
<style lang="less" scoped>
	.box {
		background: #f6f6f6;
	}

	.container {
		width: 100%;
		min-width: 1280px;
		overflow: hidden;

		.content {
			width: 1220px;
			margin: 0 auto;
			margin-top: 43px;
			// height: 799px;
			background: #fff;
			border-radius: 10px;
			display: flex;
			flex-direction: column;
			// align-items: center;
			padding-top: 86px;
			padding-left: 31px;
			padding-bottom: 93px;
			padding-right: 30px;

			.warp {
				display: flex;
				justify-content: space-between;

				.left {
					display: flex;
					align-items: center;

					.photo {
						.choose {
							width: 102px;

							.up,
							.down {
								width: 102px;
								height: 26px;
								background: rgba(8, 36, 60, 0.06);
								// opacity: 0.06;
								border-radius: 4px;
								text-align: center;
								line-height: 26px;
								cursor: pointer;
							}

							.choose-box {
								height: 472px;
								overflow: hidden;
								position: relative;
								padding-bottom: 16px;

								.wrap {
									position: absolute;

									.item {
										width: 80px;
										height: 80px;
										padding: 10px;
										border: 1px solid #d9d9d9;
										margin-top: 16px;
										cursor: pointer;

										img {
											width: 100%;
											height: 100%;
											display: block;
										}
									}

									// .item:first-child {
									//   margin-top: 0;
									// }
									// .item:last-child{
									//   margin-bottom: 16px;
									// }
								}
							}
						}
					}

					.df {
						display: flex;
						flex-direction: column;
						width: 425px;
						//   height: 444px;
						margin-left: 72px;
					}

					.img-box {
						width: 100%;
						// height: 100%;
						height: 444px;
						position: relative;
						overflow: hidden;
						margin-bottom: 50px;

						.img1 {
							width: 100%;
							height: 100%;
							position: absolute;
							z-index: 2;
						}

						.logo {
							position: absolute;
							// width: 165px;
							// height: 165px;
							object-fit: contain;
							transition: all 0.5s ease;
							z-index: 1;
						}
					}
				}

				.right {
					width: 446px;

					.uname-box {
						display: flex;
						justify-content: space-between;

						.name {
							font-size: 30px;
							font-weight: 400;
							color: #000000;
							line-height: 30px;
						}

						.follow {
							width: 90px;
							height: 35px;
							background: #08243c;
							border-radius: 18px;
							font-size: 18px;
							font-weight: 400;
							color: #ffffff;
							line-height: 35px;
							text-align: center;
							cursor: pointer;
						}
					}

					.user-info {
						display: flex;
						align-items: center;
						padding-top: 31px;

						.touxiang {
							width: 63px;
							height: 63px;
							cursor: pointer;

							img {
								width: 100%;
								height: 100%;
								display: block;
								border-radius: 50%;
							}
						}

						.user-content {
							padding-left: 27px;
							line-height: 25px;

							p:first-child {
								font-size: 18px;
								font-weight: 400;
								color: #000000;
							}

							p:last-child {
								font-size: 14px;
								font-weight: 400;
								color: #000000;
							}
						}
					}

					.shop-info {
						.shop-info-item {
							display: flex;
							align-items: center;
							justify-content: space-between;
							font-size: 16px;
							font-weight: 400;
							color: #000000;
							line-height: 25px;
							margin-top: 21px;
						}
					}

					.use-box {
						display: flex;
						align-items: center;
						justify-content: space-between;

						.no {
							font-size: 16px;
							font-weight: 400;
							color: #08243c;
							line-height: 16px;
						}

						.problem {
							font-size: 14px;
							font-weight: 400;
							color: #888888;
							line-height: 14px;
							cursor: pointer;

							span:first-child::after {
								content: "";
								width: 1px;
								height: 13px;
								background: #c6c6c6;
								display: inline-block;
								margin: 0 12px;
							}
						}
					}

					.price-box {
						background: #f1f2f3;
						border-radius: 4px;
						padding: 27px 9px;
						font-size: 16px;
						font-weight: 400;
						color: #000000;
						line-height: 16px;
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-top: 31px;
						position: relative;

						.getuser {
							font-size: 14px;
							font-weight: 400;
							color: #08243c;
							line-height: 14px;
							cursor: pointer;
						}

						.car {
							position: absolute;
							display: inline-block;
							top: 10px;
							right: 47px;
							width: 193px;
							height: 50px;
							background: #e66617;
							border-radius: 4px;
							font-size: 18px;
							font-weight: 400;
							color: #ffffff;
							line-height: 50px;
							text-align: center;
							cursor: pointer;
							animation: pulse 2s infinite;
						}

						@keyframes pulse {
							0% {
								transform: scale(1);
								background: #e66617;
							}

							50% {
								transform: scale(1.05);
								background: #fccf6b;
							}

							100% {
								transform: scale(1);
								background: #e66617;
							}
						}
					}

					.download-box {
						display: flex;
						align-items: center;
						margin-top: 49px;

						.upload {
							width: 160px;
							height: 48px;
							background: #f9f0ea;
							border: 1px solid #e66617;
							border-radius: 4px;
							font-size: 20px;
							font-weight: 400;
							color: #e66617;
							line-height: 50px;
							text-align: center;
							cursor: pointer;
						}

						.car {
							width: 193px;
							height: 50px;
							background: #f9f0ea;
							border: 1px solid #e66617;
							border-radius: 4px;
							font-size: 20px;
							font-weight: 400;
							color: #e66617;
							line-height: 50px;
							text-align: center;
							margin-left: 44px;
							display: flex;
							align-items: center;
							justify-content: center;
							cursor: pointer;
						}
					}
				}
			}
		}

		.function-box {
			margin-top: 93px;
			padding-left: 48px;
			display: flex;
			align-items: center;

			.enlarge {
				width: 298px;
				height: 53px;
				border: 1px solid #eaeaea;
				border-radius: 4px;
				display: flex;
				align-items: center;
				justify-content: space-around;
			}

			.keep {
				width: 126px;
				height: 54px;
				text-align: center;
				font-size: 16px;
				font-weight: 400;
				color: #1a3c59;
			}
		}
	}

	// 细节图
	.show {
		// width: 895px;
		//   height: 761px;
		// background: red;
		padding: 0 69px;

		img {
			width: 100%;
			height: 100%;
			display: block;
		}
	}

	.title-box {
		width: 100%;
		min-width: 1280px;

		.title {
			width: 1280px;
			margin: 0 auto;
			padding-top: 56px;
			padding-bottom: 29px;
			font-size: 24px;
			font-weight: 400;
			color: #333333;
			line-height: 24px;
		}
	}

	.pan {
		font-size: 14px;
		font-weight: 400;
		color: #000000;
	}

	.bj {
		z-index: 1111;
		width: 100%;
		height: 100%;
	}

	.el-progress {
		//   width: 300px;
		width: 75%;
	}

	.df_flex {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		position: relative;
	}

	.loader {
		// width: 40%;
		width: 75%;
		height: 25px;
		border-radius: 14px;
		border-bottom: 1px solid #fff;
		border-top: 1px solid #999;
		background: #ccc;
		// overflow: hidden;
		z-index: 5;
		// top: 90.5%;
		// left: 25%;
		position: relative;
	}

	.yellow .progress-bar {
		background: #f56c6c;
	}

	.progress-bar {
		height: inherit;
		width: 0%;
		border-radius: inherit;
		position: relative;
		overflow: hidden;
	}

	.yellow .progress-stripes {
		color: #f56c6c;
	}

	.progress-stripes {
		width: inherit;
		height: inherit;
		font-size: 180px;
		font-weight: bold;
		margin-top: -50px;
		letter-spacing: -14px;
	}

	.yellow .percentage {
		color: #fff;
	}

	.percentage {
		position: absolute;
		top: 4px;
		right: 5px;
		font-weight: bold;
		font-size: 16px;
	}

	.Hot {
		position: absolute;
		top: 50px;
		width: fit-content;
		transform: translateX(-50%);
	}

	.govip {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #000000;
		line-height: 18px;
		text-align: center;
		margin-top: 30px;
	}

	.offline {
		//padding: 12px;
		//font-size: 12px;
		background-color: #ffffff;
		//color: #08243c;
		display: flex;
		padding-top: 12px;
		justify-content: center;

		/* 水平居中 */
		//div:first-child {
		//  width: 25%;
		//}
		.money {
			margin-left: 18px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			flex-wrap: wrap;

			.inputMoney {
				display: flex;
				align-items: center;

				input {
					width: 72px;
					height: 28px;
					border: 1px #cdd6de solid;
					text-align: center;
				}
			}

			.fixed {
				width: 75px;
				height: 30px;
				text-align: center;
				line-height: 30px;
				border: 1px #cdd6de solid;
				margin-bottom: 9px;
			}

			.num-active {
				background: #f6f8f9;
			}
		}

		img {
			width: 33px;
			height: 33px;
		}
	}

	.new-car /deep/.el-dialog__body {
		padding: 0 25px 30px;
	}
</style>